import React from 'react';
import { X, AlertTriangle } from 'lucide-react';

const ConfirmationModal = ({ title, message, confirmText, cancelText, onConfirm, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4" onClick={onClose}>
            <div className="bg-white rounded-2xl w-full max-w-sm relative animate-slide-up flex flex-col" onClick={(e) => e.stopPropagation()}>
                <header className="p-4 flex justify-between items-center">
                    <h2 className="text-xl font-bold text-gray-800 flex items-center">
                        <AlertTriangle className="w-6 h-6 mr-3 text-yellow-500" />
                        {title || 'Confirmação'}
                    </h2>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200">
                        <X className="w-5 h-5" />
                    </button>
                </header>

                <main className="p-5">
                    <p className="text-gray-600 text-center">{message}</p>
                </main>

                <footer className="p-4 bg-gray-50 border-t grid grid-cols-2 gap-3">
                    <button
                        onClick={onClose}
                        className="w-full py-3 bg-gray-200 text-gray-800 font-bold rounded-xl hover:bg-gray-300 transition">
                        {cancelText || 'Cancelar'}
                    </button>
                    <button
                        onClick={onConfirm}
                        className="w-full py-3 bg-red-500 text-white font-bold rounded-xl hover:bg-red-600 transition">
                        {confirmText || 'Confirmar'}
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default ConfirmationModal;
